import React from 'react';
import { Flexer } from '../app/dashboard/elements/LayoutElements';
import { FixedScroller } from './Scrollers';

export const MenuFrame = ({ children }: { children: React.ReactNode }) => {
    return <Flexer minWidth="16" maxWidth="24">
        <FixedScroller maxHeight="24">
            {children}
        </FixedScroller>
    </Flexer>;
};

